@media (min-width: 1025px) {
  /* NGF-6687: keyed off the section's data-testid rather than a `[class*='…']` substring of the
     components CSS-module class name. That substring only existed because the class came from
     `@cx-web/components`' own prebuilt `dist/style.css` (`_footerMetaContainer_…`);
     this app compiles that CSS itself now, under the `_[name]_[hash:base64:5]` scoped-name format
     pinned in vite.config.ts, so the local name is no longer part of the class. */
  .wrapper :global([data-testid='footer-meta-section']) > div {
    height: 100px;
  }
}

.divider {
  height: 2px;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 var(--cxy-spacing-4);

  & div {
    height: 100%;
    width: 100%;
    background-color: #77777751;
  }
}
